import React, { useCallback } from 'react'
import { Form, FormRenderProps } from 'react-final-form'

import { Button, InputField } from 'Components/UI'
import validate from 'validate.js'

import { StyledForm } from './styles'

enum Field {
  Code = 'code',
}

type Props = { onSubmit?: (value: FormValues) => void }

export type FormValues = { [Field.Code]: string }

const CONSTRAINTS = {
  [Field.Code]: {
    presence: {
      allowEmpty: false,
      message: `can't be blank`,
    },
  },
}

function EnterCodeForm({ onSubmit }: Props) {
  const formValidation = useCallback(
    (values: FormValues) => validate(values, CONSTRAINTS),
    [],
  )

  const renderForm = useCallback(
    ({ handleSubmit, submitting }: FormRenderProps<FormValues>) => (
      <StyledForm onSubmit={handleSubmit}>
        <InputField displayError label="Code" name={Field.Code} width={1} />

        <Button disabled={submitting} mt={9} type="submit" width="240px">
          Continue
        </Button>
      </StyledForm>
    ),
    [],
  )

  const handleFormSubmit = useCallback(
    (values: FormValues) => {
      onSubmit?.(values)
    },
    [onSubmit],
  )

  return (
    <Form
      render={renderForm}
      validate={formValidation}
      onSubmit={handleFormSubmit}
    />
  )
}

export default EnterCodeForm
